import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  grid-column-gap: 1rem;

  && + && {
    margin-top: 1rem;
  }
`;
